<template>
  <div class="page-content">
    <el-row class="operation">
      <el-button @click="add" type="primary">添加品牌</el-button>
    </el-row>
     <!-- 数据展示区域 -->
    <el-row class="dataList">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        tooltip-effect="dark"
        :cell-style="acellStyle"
        :header-cell-style="headCellStyle"
        style="width: 100%">
        <el-table-column
         prop="brandName"
          label="品牌名称">
        </el-table-column>
        <el-table-column
         prop="brandEnName"
          label="品牌英文名称">
        </el-table-column>
        <el-table-column
         prop="createTime"
         label="创建时间">
        </el-table-column>
        <!-- <el-table-column
         prop="productModel"
          label="是否启用">
          <template slot-scope="scope">
            <el-switch
              @change="handleChange(scope.row)"
              v-model="scope.row.isUsed"
              :active-value="0"
              :inactive-value="1"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </template>
        </el-table-column> -->
        <el-table-column
          label="操作"
          >
          <template slot-scope="scope">
            <div class="opreationBtn">
              <el-button type="primary" size="mini" @click="handlerClick(scope.row, 'view')"> 查看</el-button>
              <el-button type="primary" size="mini"  @click="handlerClick(scope.row, 'edit')"> 编辑</el-button>
              <el-button type="danger" size="mini" @click="handlerClick(scope.row,'del')"> 删除</el-button>
              <el-button type="success" size="mini" @click="handlerClick(scope.row,'use')" v-if="scope.row.isEnable === 1"> 启用</el-button>
              <el-button type="warning" size="mini" @click="handlerClick(scope.row,'stop')" v-if="scope.row.isEnable === 0"> 禁用</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <Paging :total="total" @changePage="changePage"/>
    <AddBrand v-if="dialogVisible" :dialogVisible="dialogVisible" @closeDialog="closeDialog" :rowData="rowData"/>
  </div>
</template>
<script>
import Paging from '@/components/paging'
import AddBrand from '@/components/categoryManager/addBrand'
import { brandList, isUse, isDel } from '@/api/brand'
import { mixin } from '@/mixins/mixin.js'
export default {
  mixins: [mixin],
  components: {
    Paging,
    AddBrand
  },
  data () {
    return {
      dialogVisible: false,
      rowData: {},
      // 分页功能
      total: 0, // 到时候从后台获取
      listQuery: {
        page: 1,
        limit: 10
      },
      tableData: [],
      // 设置表格的样式
      acellStyle: { 'text-align': 'center' },
      headCellStyle: { 'text-align': 'center', 'font-weight': 'bold', 'font-size': '17px', color: 'black', 'background-color': '#f4f5f7' }
    }
  },
  created () {
    this.getBrandList()
  },
  methods: {
    getBrandList () {
      const params = {
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit
      }
      brandList({ params }).then((res) => {
        const result = res.data.data.data
        this.tableData = result
        this.total = res.data.data.total
      })
    },
    /* handleChange (row) {
      const params = {
        id: row.brandId,
        isDelete: row.isUsed
      }
      isUse({ params }).then((res) => {
        this.getBrandList()
        if (res.data.code === 200) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
        }
      }).catch(() => {
        // row.isUsed = !row.isUsed
        row.isUsed = ~row.isUsed + 2
      })
    }, */
    // 添加
    add () {
      this.dialogVisible = true
      this.rowData = {}
    },
    // 查看-编辑
    handlerClick (row, val) {
      const params = {
        id: row.brandId,
        isDelete: 1
      }
      this.rowData = row
      switch (val) {
        case 'view':
          this.dialogVisible = true
          this.rowData.status = 'view'
          break
        case 'edit':
          this.dialogVisible = true
          this.rowData.status = 'edit'
          break
        case 'del':
          params.isDelete = 1
          this.$confirm('是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'error'
          }).then(() => {
            isDel({ params }).then((res) => {
              if (res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '删除成功'
                })
                this.cutPage()
                this.getBrandList()
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
          break
        case 'use':
          params.isDelete = 0
          isUse({ params }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '启用成功'
              })
              this.getBrandList()
            }
          })
          break
        case 'stop':
          params.isDelete = 1
          isUse({ params }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '禁用成功'
              })
              this.getBrandList()
            }
          })
          break
      }
    },
    closeDialog (val) {
      if (val) {
        this.getBrandList()
      }
      this.dialogVisible = false
    },
    // 分页管理
    changePage (val) {
      this.listQuery = val
      this.getBrandList()
    }
  }
}
</script>

<style lang='less' scoped>
  .operation{
    margin-bottom: 10px;
  }
  .dataList{
    .opreationBtn{
        .view{
          color: #df8235;
          cursor: pointer;
        }
        .check,.edit{
          color: #35a6df;
          cursor: pointer;
        }
        .del,.stop{
          color: red;
          cursor: pointer;
        }
        span{
          margin-left: 20px;
        }
      }
  }
</style>
